import { render, staticRenderFns } from "./UploadImageAndPreview.vue?vue&type=template&id=bf806568&"
import script from "./UploadImageAndPreview.vue?vue&type=script&lang=js&"
export * from "./UploadImageAndPreview.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageAndPreview.vue?vue&type=style&index=0&id=bf806568&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports